import { FlowVendaTO, IProdutoRow } from 'pages/registra-venda/registra-venda.model';

export const possuiBrinde = (itens: IProdutoRow[]): boolean => itens.some(s => s.brinde);

export const getValorTotalBrindes = (itens: IProdutoRow[]): number =>
    itens.filter(item => item.brinde).reduce((acc, item) => acc + item.valorTotal, 0);

/**
 * O carregaPedido já retorna valorTotalBruto incluindo o valor dos brindes
 * (é a soma do valorTotal de todos os itens, brinde ou não). Por isso NÃO
 * somamos os brindes de novo — fazê-lo duplicaria o valor.
 */
export const getVTBNormalizado = (flowVendaTO: FlowVendaTO): number => {
    return flowVendaTO.itens.every(s => s.brinde) ? 0 : (flowVendaTO.valorTotalBruto ?? 0);
};

export const getValorDesconto = (flowVendaTO: FlowVendaTO): number =>
    flowVendaTO.pedidoDescontoAcrescimo.valorDesconto;

export const getValorTotalLiquido = (flowVendaTO: FlowVendaTO): number => {
    if (possuiBrinde(flowVendaTO.itens)) {
        return (
            getVTBNormalizado(flowVendaTO) -
            getValorDesconto(flowVendaTO) +
            flowVendaTO.pedidoDescontoAcrescimo.acrescimo
        );
    }
    return flowVendaTO.valorTotalLiquido ?? 0;
};

/**
 * Valor final a pagar = mercadoria líquida + frete + seguro − devolução.
 *
 * A devolução (valorTotalLiquidoTroca) abate o total: ela é lançada como um
 * pagamento OUTROS no pedido para quitar parte do valor, então aqui usamos o
 * campo de troca diretamente (somar itensPagamento contaria a devolução como
 * entrada de dinheiro, inflando o total).
 */
export const getValorAPagar = (flowVendaTO: FlowVendaTO): number =>
    getValorTotalLiquido(flowVendaTO) +
    (flowVendaTO.transportador?.valorFrete ?? 0) +
    (flowVendaTO.transportador?.valorSeguro ?? 0) -
    (flowVendaTO.valorTotalLiquidoTroca ?? 0);
